



























































































































































































import {Vue, Component} from 'vue-property-decorator';
import {mapActions} from 'vuex';
import {API} from '@/services/api/api';
import Drift from 'drift-zoom';
import {findDeckMarkerInDeckImg} from '@/utils/DeckOperations';
import {getImage, Utils} from '@/utils/Utils';

import Cropper from 'cropperjs';
import 'cropperjs/dist/cropper.css';

@Component({
  methods: {...mapActions(['showSuccessToast', 'showErrorToast'])},
})
export default class EditFrame extends Vue {
  zoneName = '';
  frameFrom: number = null;
  frameUpto: number = null;
  selectedShip = '';
  frameArray: any = [
    {
      frameFrom: null,
      frameUpto: null,
      frameFromValidationMsg: '',
      frameUptoValidationMsg: '',
    },
  ];
  showSuccessToast: any;
  showErrorToast: any;

  allFrames: any = [];

  drift: any = null;
  btnLoader = false;
  deckImageURL = '';
  isScreenLoading = true;
  scandResult: any = null;
  zoneStartPoint: number = null;
  zoneEndPoint: number = null;
  cropper = null;
  focusedEndPoint = null;

  frameFromValidationMsg = '';
  frameUptoValidationMsg = '';
  commonValidationMsg = 'This field is required';
  lengthValidationMsg = 'Can not be more than 7 digits';

  frameId: string = null;
  ZoneDeckId: number = null;
  isAutomatedEnable = true;

  //toggle between manual and automatic mode
  onToggle() {
    this.isAutomatedEnable = !this.isAutomatedEnable;
    if (!this.isAutomatedEnable && this.deckImageURL !== null) {
      this.initCropper();
    } else {
      this.destroyCropper();
    }
  }

  //Validate frame from input
  validateFrameFrom() {
    if (this.frameFrom === null || this.frameFrom.toString().length < 1) {
      this.frameFromValidationMsg = this.commonValidationMsg;
      return false;
    } else if (this.frameFrom.toString().length > 7) {
      this.frameFromValidationMsg = this.lengthValidationMsg;
      return false;
    } else {
      this.frameFromValidationMsg = '';
      return true;
    }
  }

  //validate frame upto input
  validateFrameUpto() {
    if (this.frameUpto === null || this.frameUpto.toString().length < 1) {
      this.frameUptoValidationMsg = this.commonValidationMsg;
      return false;
    } else if (this.frameUpto.toString().length > 7) {
      this.frameUptoValidationMsg = this.lengthValidationMsg;
      return false;
    } else if (Number(this.frameFrom) >= Number(this.frameUpto)) {
      this.frameUptoValidationMsg = 'Frame upto must larger than frame from';
      return false;
    } else {
      this.frameUptoValidationMsg = '';
      return true;
    }
  }

  //validate all input before submit form
  validateAll() {
    return this.validateFrameFrom() && this.validateFrameUpto();
  }

  //find frames from scaned data
  _findFrames() {
    if (this.scandResult !== null) {
      const zones = this.scandResult.Zones;

      const frames = this.scandResult.Frames;
      if (!zones || !frames) {
        this.showErrorToast({ msg: 'Frame markers not found on deck image.' });
        return;
      }

      const zone = zones.find((zone) => {
        return zone.Zone.EndPoint.X === this.zoneEndPoint;
      });

      if (zone === undefined) {
        this.showErrorToast({msg: 'Frame markers not found on deck image.'});
      } else {
        const zoneNumber = zone.Zone.ZoneNumber;
        const framesMarker = frames.filter((frame) => {
          return frame.Frame.ZoneNumber === zoneNumber;
        });

        if (framesMarker.length === 0) {
          this.showErrorToast({msg: 'Frame markers not found on deck image.'});
        } else {
          this.frameArray = [];

          const length = framesMarker.length;
          this.frameFrom = framesMarker[0].Frame.FrameNumber;
          this.frameUpto = framesMarker[length - 1].Frame.FrameNumber;
          this.frameFromValidationMsg = '';
          this.frameUptoValidationMsg = '';
        }
      }
    } else {
      this.showErrorToast({msg: 'Frames not found'});
    }
  }

  //form handler
  async _updateHandler() {
    if (this.validateAll()) {
      try {
        this.btnLoader = true;
        const frameData = [];
        frameData.push({
          frameFrom: this.frameFrom,
          frameUpto: this.frameUpto,
          id: this.frameId,
        });

        const response = await API.updateFrame({
          ZoneDeckId: this.ZoneDeckId,
          frameofZones: frameData,
        });
        if (response.data) {
          this.showSuccessToast({msg: response.message});
          this._clearForm();
          this.changeTabs();
        } else {
          this.showErrorToast({msg: response.error});
        }
      } catch (error) {
        this.showErrorToast({msg: 'Network Error'});
      } finally {
        this.btnLoader = false;
      }
    }
  }

  //go to back
  changeTabs() {
    this.$router.go(-1);
  }

  destroyed() {
    document.body.removeEventListener('keydown', this.keyDownEvent);
  }

  //Clear form
  _clearForm() {
    this.selectedShip = '';
    this.zoneName = '';
    this.frameFrom = null;
    this.frameUpto = null;
  }

  //life cycle hook call on page mounted
  mounted() {
    this.frameId = this.$route.params.id;
    this.getFrameData();
    document.body.addEventListener('keydown', this.keyDownEvent);
  }

  keyDownEvent(event) {
    let e = event || window.event;
    Utils.keyDownEvent(e, this.cropper);
  }

  //cropbox auto initialize after image load
  onDeckLoad() {
    if (!this.isAutomatedEnable && this.deckImageURL !== null) {
      this.initCropper();
    }
  }

  // initialize crop box on image
  initCropper() {
    const t = this.$refs.image as HTMLImageElement;
    const _this = this;
    this.cropper = new Cropper(t, {
      crop() {
        const data = this.cropper.getData(true);
        _this.frameFrom = data.x;
        _this.frameUpto = data.x + data.width;
        _this.frameFromValidationMsg = '';
        _this.frameUptoValidationMsg = '';
      },
      preview: document.getElementById('ppppp'),
      viewMode: 2,
      data: {
        x: t.naturalWidth / 3,
        y: t.naturalHeight / 3,
        width: t.naturalWidth / 3,
        height: t.naturalHeight / 3,
      },
    });
  }

  //destroy crop box cropper
  destroyCropper() {
    if (this.cropper) {
      this.cropper.destroy();
      this.cropper = null;
    }
  }

  focusOnEndPoint(index) {
    this.focusedEndPoint = index;
  }

  blurOnEndPoint(index) {
    if (this.focusedEndPoint === index) {
      this.focusedEndPoint = null;
    }
  }

  // get frame data
  async getFrameData() {
    try {
      const response = await API.fetchFrameDetailsBYId(this.frameId);

      if (response.data) {
        const frameData = response.data;

        this.ZoneDeckId = frameData.zoneDeckId;
        this.selectedShip = frameData.zone.drawing.ship.name;
        this.scandResult = Utils.parseJson(frameData.zone.drawing.scanResult);
        this.zoneName = frameData.zoneName;

        this.zoneEndPoint = frameData.zoneEndPoint;

        this.setDeckImage(frameData);
      } else {
        this.showErrorToast({msg: response.message});
      }
    } catch (error) {
      this.isScreenLoading = false;
      this.showErrorToast({msg: 'Network error'});
    } finally {
      this.isScreenLoading = false;
    }
  }

  async setDeckImage(frameData) {
    if (frameData.zone.drawing.fileName !== null || frameData.zone.drawing.fileName.length > 0) {
      try {
        this.isScreenLoading = true;

        this.deckImageURL = await getImage(frameData.zone.drawing.imagePath);
        this.frameArray = [];
        this.frameArray = frameData.frameofZones.map((frame) => ({
          ...frame,

          frameFromValidationMsg: '',
          frameUptoValidationMsg: '',
        }));
        this.frameFrom = this.frameArray[0].frameFrom;
        this.frameUpto = this.frameArray[0].frameUpto;
        this.frameId = this.frameArray[0].id;

        //
      } catch (error) {
        this.showErrorToast({msg: 'Something went wrong'});
      } finally {
        this.isScreenLoading = false;
      }
    }
  }

  //initialize zoomed container on hover imag
  initDriftZoom() {
    document.querySelectorAll('.drift-bounding-box').forEach((element) => {
      element.remove();
    });
    this.isAutomatedEnable
      ? (this.drift = new Drift(this.$refs.image, {
          paneContainer: document.getElementById('ppppp'),
          // inlinePane: 900,
          inlineOffsetY: -85,
          containInline: true,
          handleTouch: false,
          inlinePane: false,
          hoverBoundingBox: true,
        }))
      : null;
  }
  //disable zoomed container on hover image
  disableDriftZoom() {
    if (this.drift) {
      this.drift.destroy();
    }
  }

  _reseImage() {
    if (this.cropper) {
      this.cropper.reset();
    }
  }
}
